import { render, staticRenderFns } from "./EditionButtons.vue?vue&type=template&id=c6cce86a&scoped=true"
import script from "./EditionButtons.vue?vue&type=script&lang=js"
export * from "./EditionButtons.vue?vue&type=script&lang=js"
import style0 from "./EditionButtons.vue?vue&type=style&index=0&id=c6cce86a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6cce86a",
  null
  
)

export default component.exports